// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__37hrH","box":"WorkspacesBox_box__3zAyv","node":"WorkspacesBox_node__Nv718"};